export const isFulfilledAction = (prefix) => (action) =>
  action.type.startsWith(prefix) && action.type.endsWith('/fulfilled');

export const isPendingAction = (prefix) => (action) =>
  action.type.startsWith(prefix) && action.type.endsWith('/pending');

export const isRejectedAction = (prefix) => (action) =>
  action.type.startsWith(prefix) && action.type.endsWith('/rejected');
